<template>
    <div>
        <ul class="station-list clearfix">
            <li class="station-li" :class="{active:index == tabindex}" @click="tabsChange(index)" v-for="(item,index) in tabList">{{item}}</li>
        </ul>
        <div style="box-shadow:0 0 7px 0 #cbcbcb;background-color: #fff;">
            <ul class="resume-list" style="box-shadow:none;">
                <li class="resume-li" v-for="item in rowsList">
                    <div class="img" style="border-radius: 50%;background: #fff;">
                        <img :src="item.headImage?item.headImage:'//oss.51ztx.com/resu.png'" alt="">
                    </div>
                    <div class="resume-liinfo">
                <div class="infomain">
                    <div class="info">
                        <div class="tit">
                            <div class="tit-name">{{item.name}}</div>
                            <div v-if="item.expectPositionName">
                                <div class="tit-img"><img src="../../assets/images/qian_ico.png"></div>
                                <div class="tit-post">{{item.expectPositionName}}</div>
                            </div>

                            <div class="tit-post" style="border-left:1px solid #666;margin-left:10px;padding-left:10px;">{{item.expectCityname}}</div>
                        </div>

                        <div class="price-range" v-if="item.expectMinsalary">￥{{item.expectMinsalary}}~{{item.expectMaxsalary}}</div>
                        <!--<div class="price-range" v-else>暂无</div>-->

                    </div>
                    <div class="infob" style="overflow:hidden;">
                        <div class="fl" style="overflow:hidden;">
                            <div>
                                <ul class="spec" style="float:none;overflow:hidden;">
                                <li v-if="item.sex">{{item.sex}}</li>
                                <li v-if="item.age">{{item.age}}岁</li>
                                <li v-if="item.education">{{item.education}}</li>
                            </ul>
                            <div v-if="item.experience" class="spec-exp" style="overflow:hidden;">
                                <i class="iconfont icon-briefcase_ico"></i>
                                <p v-if="item.experience != '无经验'">{{item.experience}}工作经验</p>
                                <p v-else>{{item.experience}}</p>
                            </div>
                            </div>
                        </div>
                        <div class="time" v-if="item.updatedAt">
                            <i class="iconfont icon-time_ico1"></i>
                            <span>{{item.updatedAt}}</span>
                        </div>

                    </div>
                </div>
                <div class="resume-btn-groups">
                    <router-link class="resumebtn resumebtn-blue" target="_blank" :to="{path:'/index/resume/seeinfo',query:{workerId:item.id}}">查看简历</router-link>
                </div>
            </div>
                </li>
            </ul>
            <ztx-paging class="ztx-paging" v-if="pageTotal > -1" :page-num="pageNum" :page-total="pageTotal" @currentChange="handleCurrent"></ztx-paging>
        </div>

    </div>
</template>
<script>
import Pageing from '../../components/Pageing'
export default {
    data() {
        return {
            pageNum: 1,
            tabindex: 0,
            tabList: [],
            rowsList: [],
            pageTotal: -1
        }
    },
    created() {
        this.getList();
    },
    components: {
        ztxPaging: Pageing
    },
    methods: {
        // 分页变化
        handleCurrent(val) {
            this.pageNum = val;
            this.getList();
        },
        seeResume(id) {
            this.$router.push({ path: '/index/resume/seeinfo', query: { workerId: id } });
        },
        tabsChange(val) {
            this.tabindex = val;
        },
        getList() {
            let url = `/wapi/hr/pageCollWorker?pageNum=${this.pageNum}`;
            this.axios.get(url)
                .then(res => {
                    this.rowsList = res.rows;
                    this.pageTotal = res.total;
                })
        }
    }

}
</script>
<style lang="less" scoped>
@import "../../assets/css/variable";
@import "../../assets/css/talent";
.station-list {
    .station-li {
        width: 106px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
        color: #888;
        box-shadow: 0 0 7px #cbcbcb;
        float: left;
        margin-right: 10px;
        position: relative;
        top: 4px;
    }
    .active {
        background-color: @blue;
        color: #fff;
        top: 0;
    }
}
.ztx-paging{
    background-color: #fff;
    padding-bottom: 22px;
}
</style>



// WEBPACK FOOTER //
// mylist.vue?4d06dc20